export const round2 = (num: number): number => Math.round(num * 100) / 100;
